
import { Component } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import Notification from '@/mixins/Notification';
import { mixins } from 'vue-class-component';
import VFormBuilder from '../../components/shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import AuthApiService from '@/api/http/AuthApiService';

@Component({
  components: { VFormBuilder, VWrapper },
})
export default class ForgotPassword extends mixins(Notification) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any; validate: () => Promise<boolean | boolean[]> };
  };

  get items() {
    return [{ type: InputType.Text, name: 'email', rules: 'required|email', label: 'auth.form.email' }];
  }

  public reset() {
    this.$refs.form.validate().then((res: boolean) => {
      if (res) {
        const api: AuthApiService = new AuthApiService();
        const data: { email: string } = this.$refs.form.form;
        api.forgotPassword(data).then(() => {
          this.notifyInfo('auth.notification.forgotPassword');
          this.$router.push({ name: 'start' });
        });
      } else {
        this.notifyError('notification.form');
      }
    });
  }
}
